<template><section><template>
<h3>Rate</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-rate v-model="value"></n3-rate>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-rate</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-rate</span>&gt;</span>
</code></pre>
<p><n3-rate v-model="value1" allow-half=""></n3-rate></p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-rate</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value1"</span> <span class="hljs-attr">allow-half</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-rate</span>&gt;</span>
</code></pre>
<p><n3-rate v-model="value2" show-text="" :colors="['#ffeb3b','#ff9800','#f44336']"></n3-rate></p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-rate</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value2"</span> <span class="hljs-attr">show-text</span> <span class="hljs-attr">:colors</span>=<span class="hljs-string">"['#ffeb3b','#ff9800','#f44336']"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-rate</span>&gt;</span>
</code></pre>
</div>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>max</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">5</code></td>
<td>max number</td>
</tr>
<tr>
<td>allow-half</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>allow half</td>
</tr>
<tr>
<td>colors</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">['#F7BA2A', '#F7BA2A', '#F7BA2A']</code></td>
<td>color</td>
</tr>
<tr>
<td>voidColor</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">#C6D1DE</code></td>
<td>Unchecked color</td>
</tr>
<tr>
<td>disabledVoidColor</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">#EFF2F7</code></td>
<td>disable the selected color</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>disabled</td>
</tr>
<tr>
<td>disabled-void-icon</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">star</code></td>
<td>Disable the icon for the operation</td>
</tr>
<tr>
<td>void-icon</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">star-o</code></td>
<td>Unchecked icon</td>
</tr>
<tr>
<td>icons</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">['star', 'star', 'star']</code></td>
<td>checked icon</td>
</tr>
<tr>
<td>show-text</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>Whether to show text interpretation</td>
</tr>
<tr>
<td>text-color</td>
<td><code v-pre="">string</code></td>
<td><code v-pre="">#1f2d3d</code></td>
<td>Text color</td>
</tr>
<tr>
<td>texts</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">[]</code></td>
<td>Text</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
  export default {
    data () {
      return {
        value: 3,
        value1: 2.5,
        value2: 4
      }
    }
  }
</script>


// WEBPACK FOOTER //
// n3RateDocs.md?740dc29a